import { useStore, useStoreMap } from 'effector-react'
import { useForm } from 'react-hook-form'
import {
  Form,
  Title,
  Characteristics,
  MainBlock,
  FormValues,
  Address,
} from '~/entities/BookingCar'
import { Taxipark } from '~/entities/BookingCar/ui/Taxipark'
import { driverModel } from '~/entities/Driver'
import { viewerModel } from '~/entities/viewer'
import { rentalContractQuantityOfHoursLabels } from '~/shared/config/constants'
import {
  RentalContractQuantityOfHoursEnum,
  RentalContractWorkScheduleEnum,
} from '~/shared/config/enums'
import { BookingAuth } from './BookingAuth'
import { BookingUnAuth } from './BookingUnAuth'
import { $bookingCar } from './model'
import { PromoCode } from './PromoCode'
import { Wrapper, PriceWrapper } from './styled'
import { PriceBlock } from './ui/Price'

const defaultValues = {
  workSchedule: {
    id: RentalContractWorkScheduleEnum.FULL_WEEK,
    label: RentalContractWorkScheduleEnum.FULL_WEEK,
  },
  quantityRentalPayments: {
    id: RentalContractQuantityOfHoursEnum.TWELVE_WRITE_OFF,
    label:
      rentalContractQuantityOfHoursLabels[
        RentalContractQuantityOfHoursEnum.TWELVE_WRITE_OFF
      ],
  },
  dayOff: null,
}

export function BookingCar() {
  const authenticated = viewerModel.useAuthenticated()

  const bookingCar = useStore($bookingCar)
  const inspectionId = bookingCar?.getInspectionId()
  const taxiparkId = bookingCar?.getTaxipark()?.getApiId()

  const location = useStoreMap($bookingCar, (bookingCar) =>
    bookingCar?.getLocation(),
  )

  const driverId = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getExitId(),
  )

  const carId = bookingCar?.getApiId()

  const form = useForm<FormValues>({
    defaultValues,
  })
  const { watch } = form
  const formValues = watch()

  if (!bookingCar) return null

  const getPlateNumber = bookingCar.getPlateNumber()
  const pricePerDay = bookingCar.getPricePerDay()
  const photos = bookingCar.getPhotos()
  const isLeasingFullyPaid = bookingCar.getIsLeasingFullyPaid()
  const taxiparkName = bookingCar.getTaxipark()?.getName()
  const discount = bookingCar.getDiscount()
  const { workSchedule } = formValues

  return (
    <Wrapper>
      <MainBlock
        plateNumber={getPlateNumber}
        photos={photos}
        isLeasingFullyPaid={isLeasingFullyPaid}
        inspectionId={inspectionId}
        taxiparkId={taxiparkId}
        discount={discount}
        pricePerDay={pricePerDay}
      />

      <PriceWrapper>
        <Title>Стоимость аренды</Title>
        <Form instanceForm={form} />
        {authenticated && (
          <PromoCode form={form} driverId={driverId} carId={carId} />
        )}
        <PriceBlock
          pricePerDay={pricePerDay}
          discount={discount}
          workSchedule={workSchedule}
        />
      </PriceWrapper>

      <Characteristics bookingCar={bookingCar} />

      <Taxipark name={taxiparkName} />

      <Address name={location?.getName()} />

      {authenticated ? (
        <BookingAuth formValues={formValues} />
      ) : (
        <BookingUnAuth />
      )}
    </Wrapper>
  )
}
